<template lang="pug">
  #app.main-layout
    main-header()
    left-menu()
    section
      //TODO переделать эту обработку ошибок под что-то более дружественное, чем перенаправление на новую страницу (!!!)
      //e-error(v-if="error" :error="error")
      router-view
    // main-footer()
</template>
<script>
  export default {
    name: 'main-layout',
    computed: {
      error () {
        return this.$store.getters.getError
      }
    }
  }
</script>
